import { z } from 'zod/v4';
export const booleanSchema = z.union([
    z.boolean(),
    z.enum(['true', 'false']).transform((value) => value === 'true'),
]);
//# sourceMappingURL=schema.js.map